import React, { useMemo } from 'react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import { ChatCreateContainerProps, ChatCreateViewProps } from './chatCreateProps';
import { ChatCreateController, ChatCreateLoader } from './chatCreateInterface';

export function createChatCreateContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatCreateLoader,
    controller: ChatCreateController,
    View: React.FC<ChatCreateViewProps>
): React.FC<ChatCreateContainerProps> {
    const {
        repository: { assistant },
        context: { useContext },
    } = config;

    return config.state.chat.subscribe(({ ...containerProps }) => {
        const context = useContext();
        const state = config.state.chat.useState(context);
        const mutation = {
            thread: {
                create: assistant.thread.useCreate(context),
            },
        };
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            async onSubmit(values) {
                console.log('creating thread', values);
                const response = await mutation.thread.create.mutateAsync({
                    title: 'Unnamed chat',
                    metadata: {},
                });
                console.log('new thread created', response);
                console.log('setting current thread', response.id);
                state.onChange({
                    thread: response.id,
                    enqueuedMessages: [
                        {
                            context: [],
                            parts: [
                                {
                                    type: 'text',
                                    text: values.text,
                                },
                            ],
                            idempotencyKey: new Date().getTime().toString(),
                        },
                    ],
                });
                return;
            },
            onOpen(thread) {
                console.log('opening thread', thread);
                state.onChange({
                    thread: thread.id,
                });
            },
        });
        return <View {...props} />;
    });
}
